(() => {
  // scripts/8080.js
  console.log(8080);
  var localizationForm = document.querySelector("#currency-switcher form");
  if (localizationForm) {
    const selects = localizationForm.querySelectorAll("select");
    selects && selects.forEach((select) => {
      select.addEventListener("change", (e) => {
        localizationForm.submit();
      });
    });
  }
})();
